import { Grid } from '@material-ui/core';
import React, { FC } from 'react';
import CheckIcon from '@material-ui/icons/Check';
import { useStyles } from './styles';
import { useStore } from 'hooks/useRootStore';
export const CoreFeatures: FC = () => {
  const {
    upgradeLicenseStore: { upgradelicenseplan },
  } = useStore();
  const classes = useStyles();

  return (
    <>
      <Grid container className={classes.featuredetail}>
        {upgradelicenseplan.map(
          (feature) =>
            feature.name === 'Core' &&
            feature.list.map((values, index) => (
              <Grid key={index} className={classes.featuredetailicon} item xs={6} md={4}>
                <CheckIcon className={classes.featureicons} /> <span>{values}</span>
              </Grid>
            ))
        )}
      </Grid>
    </>
  );
};
